import styled, { css } from "styled-components";
import Datepicker from "react-datepicker";

interface PropsFormControl {
  tabFocus: boolean;
  focus: boolean;
  error: boolean;
  disabled: boolean;
}

export const FormControl = styled.div<PropsFormControl>`
  display: flex;
  flex-direction: column;
  .tabFocus {
    display: flex;
    flex-direction: column;
  }
  ${(props) =>
    props.tabFocus &&
    css`
      .tabFocus {
        ${(props) => props.theme.states.focus};
      }
    `}
  ${(props) =>
    props.focus &&
    css`
      label {
        ${(props) => props.theme.states.actived.label};
      }
      .input-wrapper {
        ${(props) => props.theme.states.actived.inputWrapper};
      }
    `}
  ${(props) =>
    !props.disabled &&
    css`
      &:hover {
        .input-wrapper {
          ${(props) => props.theme.states.hover.inputWrapper}
        }
      }
    `}
  ${(props) =>
    props.error &&
    css`
      label {
        ${(props) => props.theme.states.error.label}
      }
      .input-wrapper {
        ${(props) => props.theme.states.error.inputWrapper}
      }
      span {
        ${(props) => props.theme.states.error.helper}
      }
    `}
  ${(props) =>
    props.disabled &&
    css`
      label {
        ${(props) => props.theme.states.disabled.label}
      }
      .input-wrapper {
        ${(props) => props.theme.states.disabled.inputWrapper}
      }
      span {
        ${(props) => props.theme.states.disabled.helper}
      }
    `}


    .tmp-icon:hover {
      cursor:pointer;
    }
`;

export const Label = styled.label`
  ${(props) => props.theme.label};
  ${(props) => props.theme.motion}
`;

export const InputWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  ${(props) => props.theme.inputWrapper};
  ${(props) => props.theme.motion}
  .tmp-icon {
    ${(props) => props.theme.icon}
  }
`;

export const DatepickerComponent = styled(Datepicker)`
  position: relative;
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  width: 100%;
  height: 56px;
  ${(props) => props.theme.input};
  ${(props) => props.theme.motion}
  &::placeholder {
    ${(props) =>
      props.disabled
        ? props.theme.states.disabled.placeholder
        : props.theme.placeholder};
  }
  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`;

export const Helper = styled.span`
  display: flex;
  ${(props) => props.theme.helper};
  .icon {
    ${(props) => props.theme.helper.icon};
  }
`;
export const Wrapper = styled.div`
  .react-datepicker-popper {
    z-index: 1;
    @media(max-width: 768px) {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      transform: none !important;
      width: 100vw;
      height: 100vh;
      padding: 0;
      margin: 0;
      > div {
        height: 100%;
        .react-datepicker{
          height: 100%;
        }
      }
    }
  } 
  .react-datepicker__portal {
    > div {
      max-width: 100%;
      height: 100%;
    }
    .react-datepicker {
      height: 100%;
      border-radius: 0;
      padding: 12px;
    }
    .tmp-button-group {
      margin-top: auto;
    }
  }

  .react-datepicker {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    ${(props) => props.theme.structure}
    .tmp-button-group {
      margin-top: 16px;
    }
    @media (max-width: 769px) {
      max-width: 100vw;
    }
  }

  .react-datepicker__header {
    background: transparent;
    border-bottom: 0;
    padding: 0;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      ${(props) => props.theme.verticalSpacing.month}
    }
  }
  .react-datepicker__current-month {
    display: flex;
    justify-content: center;
    margin: 0;
    .tmp-typography {
      &:first-letter {
        text-transform: uppercase;
      }
    }
  }
  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__month-container {
    width: 100%;
  }
  .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${(props) => props.theme.verticalSpacing.weekDays}
  }
  .react-datepicker__day-name {
    display: flex;
    justify-content: center;
    align-items: center;
    ${(props) => props.theme.day}

    text-transform: uppercase;
  }
  .react-datepicker__week {
    display: flex;
    ${(props) => props.theme.verticalSpacing.lineDays}
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
  .react-datepicker__day {
    justify-content: center;
    display: flex;
    align-items: center;
    flex: 1 0 auto;
    ${(props) => props.theme.number}
    ${(props) => props.theme.motion}
    @media(max-width: 320px) {
      margin: 0;
    }
    &--outside-month,
    &--excluded {
      ${(props) => props.theme.number.inactive}
    }
    &--disabled {
      ${(props) => props.theme.number.inactive}
    }
    &--selected {
      ${(props) => props.theme.number.selected}
    }
    &--keyboard-selected {
      background: initial;
      ${(props) => props.theme.number}
    }

    &[aria-disabled="false"] {
      &:hover {
        ${(props) => props.theme.states.hover.number}
      }
    }
  }

  .tmp-button-group {
    width: 100%;
    justify-content: center;
    display: flex;
    @media (min-width: 768px) {
      /*display: none;*/
    }
  }
`;
